module.exports = __webpack_public_path__ + "static/media/NZ.983ed8a7.svg";